import { useMemo } from 'react';
import { usePerpMarkets } from './usePerpMarkets';
import { PerpMarketConfig } from '@drift-labs/sdk';

export const usePerpMarketsLookup = () => {
	const perpMarkets = usePerpMarkets();
	const maxPerpMarketIndex = useMemo(
		() => Math.max(...perpMarkets.map((market) => market.marketIndex)),
		[perpMarkets]
	);
	return useMemo(() => {
		const lookup: PerpMarketConfig[] = new Array(
			maxPerpMarketIndex > 0 ? maxPerpMarketIndex : 1
		);

		perpMarkets.forEach((market) => {
			lookup[market.marketIndex] = market;
		});

		return lookup;
	}, [perpMarkets, maxPerpMarketIndex]);
};
